import { render, staticRenderFns } from "./registar_abastecimento.vue?vue&type=template&id=cb14ff44&scoped=true&"
import script from "./registar_abastecimento.vue?vue&type=script&lang=js&"
export * from "./registar_abastecimento.vue?vue&type=script&lang=js&"
import style0 from "./registar_abastecimento.vue?vue&type=style&index=0&id=cb14ff44&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb14ff44",
  null
  
)

export default component.exports